/**
 * SheSteps cart and scroll reliability guard.
 *
 * Custom product sections all emit the Horizon `cart:update` event. The cart
 * drawer must be opened once, after every synchronous cart listener has
 * finished updating its markup. A single guarded handler avoids competing
 * showModal() calls and the orphaned body lock they can create on mobile.
 */

let cartOpenQueued = false;

function openCartDrawerOnce(event) {
  if (event.detail?.data?.didError || cartOpenQueued) return;

  cartOpenQueued = true;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      cartOpenQueued = false;

      const drawer = document.querySelector('cart-drawer-component');
      const dialog = drawer?.querySelector('dialog');

      if (!drawer || dialog?.open) return;

      if (typeof drawer.open === 'function') {
        drawer.open();
      } else if (typeof drawer.showDialog === 'function') {
        drawer.showDialog();
      }
    });
  });
}

function clearOrphanedScrollLock() {
  const hasOpenNativeDialog = Boolean(document.querySelector('dialog[open]'));
  const hasOpenSizeModal = Boolean(document.querySelector('.she-size-modal.is-open'));

  if (hasOpenNativeDialog || hasOpenSizeModal) return;

  if (document.body.style.position === 'fixed') {
    const lockedTop = Number.parseInt(document.body.style.top || '0', 10);
    const restoreY = Number.isFinite(lockedTop) ? Math.abs(lockedTop) : window.scrollY;

    document.body.style.width = '';
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo({ top: restoreY, behavior: 'instant' });
  }

  if (document.body.style.overflow === 'hidden') {
    document.body.style.overflow = '';
  }
}

document.addEventListener('cart:update', openCartDrawerOnce);
document.addEventListener('dialog:close', () => setTimeout(clearOrphanedScrollLock, 0), true);
window.addEventListener('pageshow', clearOrphanedScrollLock);
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) clearOrphanedScrollLock();
});
